export const MECHANISM_PERCENT = 2;
export const MECHANISM_FULL = 1;

export const DEBT_STATUS = {
  Pending: 0,
  Ongoing: 1,
  Paused: 2,
  Completed: 3,
  Closed: 4,
};

export const NAVY = "#181c32";
export const CARD_BORDER = "#e4e6ef";

export const DEBT_TITLE_FONT_SIZE = "1.5rem";
export const DEBT_TITLE_STYLE = {
  fontSize: DEBT_TITLE_FONT_SIZE,
  fontWeight: 600,
  color: "#181C32",
  lineHeight: 1.2,
};

export const DEBT_CARD_TITLE_FONT_SIZE = "1.25rem";
export const CURRENT_CONFIG_TITLE_STYLE = {
  color: NAVY,
  fontSize: DEBT_CARD_TITLE_FONT_SIZE,
  fontWeight: 700,
};

export const CLOSE_ALERT_BG = "#fffbeb";
export const CLOSE_ALERT_BORDER = "#fcd34d";
export const CLOSE_ALERT_TEXT = "#92400e";

export const DEBT_DRAWER_MAX_WIDTH = "min(1100px, 94vw)";
export const DEBT_DRAWER_CANCEL_BG = "#1f2937";
export const DEBT_DRAWER_PRIMARY_ACTION = "#ff7000";

/** When multiple rows exist, prefer the newest row within this status order. */
export const DEBT_DETAIL_DISPLAY_STATUS_PRIORITY = [
  DEBT_STATUS.Ongoing,
  DEBT_STATUS.Pending,
  DEBT_STATUS.Paused,
  DEBT_STATUS.Closed,
  DEBT_STATUS.Completed,
];

export const DEBT_SUPER_ADMIN_BADGE = {
  color: "#6D28D9",
  backgroundColor: "#EDE9FE",
};
